module.exports = __webpack_public_path__ + "static/media/create_reservation_select_office.953888ac.jpg";